<div class="relative w-full h-full overflow-hidden" #gridContainer>
  <sia-grid
    [gridHeight]="gridContainer.offsetHeight"
    (gridSaved)="onGridSaved($event)"
    (gridAction)="onGridAction($event)"
  ></sia-grid>
</div>
